import React from 'react';

class Pagination extends React.Component {
  render() {

    const { page, total_pages } = this.props.pagination;
    if (total_pages < 2) {
      return ''
    }

    const disabledLeft = (page === 1) ? "disabled" : "waves-effect"
    const disabledRight = (page === total_pages) ? "disabled" : "waves-effect"
    let pages = [];
    for (let i = 1; i <= total_pages; i++) {
      const classname = ( i === page ) ? "active" : "waves-effect";
      pages.push(
        <li className={classname} key={i}><a href="" onClick={(e) => {
  					e.preventDefault()
  					this.props.fetchPage(i)
  				}
        }>{i}</a></li>
      )
    }

    return (
      <ul className="pagination center-align">
        <li className={disabledLeft}><a href="" onClick={(e) => {
  					e.preventDefault()
  					this.props.fetchPage(1)
  				}
        }><i className="material-icons">chevron_left</i></a></li>
        { pages }
        <li className={disabledRight}><a href="" onClick={(e) => {
  					e.preventDefault()
  					this.props.fetchPage(total_pages)
  				}
        }><i className="material-icons">chevron_right</i></a></li>
      </ul>
    )
  }
}

export default Pagination;



// WEBPACK FOOTER //
// ./src/js/components/Pagination.js